import { render, staticRenderFns } from "./AwsSettings.vue?vue&type=template&id=c933dca0"
import script from "./AwsSettings.vue?vue&type=script&lang=js"
export * from "./AwsSettings.vue?vue&type=script&lang=js"
import style0 from "./AwsSettings.vue?vue&type=style&index=0&id=c933dca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports